import { render, staticRenderFns } from "./AttachmentTile.vue?vue&type=template&id=04931638"
import script from "./AttachmentTile.vue?vue&type=script&lang=js"
export * from "./AttachmentTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports